<template>
  <div class="attr-material" v-if="value">
    <!--<h3 class="c-ellipsis">{{value.originName}}</h3>-->
    <section v-if="!tplData.free">
      <h4>素材操作设置</h4>
      <ul>
        <li>
          <el-checkbox v-model="value.disabled" key="1">禁止操作</el-checkbox>
          <!--<a class="example">示例</a>-->
        </li>
        <li>
          <el-checkbox v-model="value.fixed" key="2">禁止联动</el-checkbox>
          <!--<a class="example">示例</a>-->
        </li>
        <li>
          <el-checkbox v-model="value.allowHide" key="3">支持隐藏</el-checkbox>
          <!--<a class="example">示例</a>-->
        </li>
      </ul>
    </section>
    <section v-if="isSingleTemplate">
      <h4>素材属性设置</h4>
      <div>
        <el-radio-group v-model="bgVal" @change="onSingleBgValChange">
          <el-radio-button label="0">无</el-radio-button>
          <el-radio-button label="3">模板背景</el-radio-button>
          <el-radio-button label="4">行动点背景</el-radio-button>
        </el-radio-group>
      </div>
    </section>
    <section v-else>
      <h4>素材属性设置</h4>
      <div>
        <el-radio-group v-model="bgVal" @change="onMultiBgValChange">
          <el-radio-button label="0">无</el-radio-button>
          <el-radio-button label="1" v-if="!tplData.free">背景</el-radio-button>
          <el-radio-button label="2" v-if="!tplData.free"
            >背景素材</el-radio-button
          >
          <el-radio-button label="3">{{
            tplData.free ? '背景' : '模板背景'
          }}</el-radio-button>
        </el-radio-group>
      </div>
    </section>
    <section v-if="isTemplateBg">
      <h4>背景设置</h4>
      <div>
        <el-button
          style="width: 100%"
          class="c-btn-color"
          @click="onUploadBg"
          :title="`建议尺寸${tplData.widthHeight}`"
          >上传背景</el-button
        >
      </div>
    </section>
    <section>
      <h4>素材透明度%</h4>
      <opacity v-model="value.opacity"></opacity>
      <!--<div class="slider-input-body">-->
      <!--<el-slider v-model="opacity" :format-tooltip="formatterOpacityTip" @change="onOpacityChange"></el-slider>-->
      <!--<span class="ipt">-->
      <!--<el-input-number class="" controls-position="right" :max="100" :min="0" style="width: 100px" size="small"-->
      <!--v-model="opacity"></el-input-number></span>-->
      <!--</div>-->
    </section>
    <section>
      <h4>素材大小</h4>
      <div>
        <el-button
          style="width: 100%"
          class="c-btn-color"
          @click="onOpenMaterialDialog"
          title="扩大素材范围"
          >设置素材尺寸</el-button
        >
        <material-dialog
          v-model="dialogVisible"
          :data="value"
          @onConfirm="onConfirm"
        ></material-dialog>
      </div>
    </section>
    <section v-if="!tplData.free">
      <h4>遮照层设置</h4>
      <div>
        <color-input
          v-model="value.coverBackgroundColor"
          @onChange="onCoverBgChange"
        ></color-input>
      </div>
    </section>
    <section v-if="!tplData.free">
      <h4>素材扩展</h4>
      <div>
        <el-radio-group
          v-model="value.direction"
          @change="onDirectionChange($event)"
        >
          <el-radio-button label="">无</el-radio-button>
          <el-radio-button label="horizontal">水平扩展</el-radio-button>
          <el-radio-button label="vertical">垂直扩展</el-radio-button>
          <el-radio-button label="two-direction">双向扩展</el-radio-button>
        </el-radio-group>
      </div>
    </section>
    <section>
      <h4>圆角</h4>
      <div>
        <label>自定义圆角</label>
        <div class="slider-input-body">
          <el-slider v-model="value.borderRadius"></el-slider>
          <span class="ipt">
            <el-input-number
              v-model="value.borderRadius"
              :max="100"
              class="radius-input"
              @change="onBorderRadiusChange"
              size="small"
              controls-position="right"
            ></el-input-number>
          </span>
        </div>
        <p>
          <el-checkbox
            v-model="value.isCircle"
            class="set-circle"
            @change="onBorderRadiusChange"
            >设置为圆形</el-checkbox
          >
        </p>
      </div>
    </section>
    <section v-if="!tplData.free">
      <h4>拼图</h4>
      <div>
        <p>
          <el-checkbox v-model="value.isGroupMaterial">支持拼图</el-checkbox>
        </p>
        <div class="pintu-list" v-if="value.isGroupMaterial">
          <ul>
            <li v-for="(item, index) in pintuList" :key="index">
              <div class="gl-img-box bg-hover">
                <img :src="item.coverUrl" />
                <span class="del-bg">
                  <i
                    class="el-icon-delete del-icon"
                    @click="onDelGroupItem(item, index)"
                  ></i>
                </span>
              </div>
              <p class="gl-img-name">{{ item.name }}</p>
            </li>
          </ul>
          <div class="upload-btn">
            <pintu-uploader
              @onCompleted="onUploadCompleted"
              :template-id="tplData.id"
              :project-id="tplData.projectId"
              :auto-save="false"
            >
              <template slot-scope="slotData">
                <el-button
                  round
                  type="default"
                  plain
                  icon="el-icon-plus"
                  :disabled="slotData.loading"
                >
                  {{ slotData.loading ? '上传中...' : '上传拼图素材' }}
                </el-button>
              </template>
            </pintu-uploader>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { group_type_pt, template_type_single } from '@/const.js'
import groupService from '../../../request/service/group-service'
import pintuUploader from '../../template/img-template/uploader'
import materialDialog from './material-edit-dialog'
import util from '@/util.js'
import colorInput from '../../components/color-input'
import ImgCoverUtil from './ImgCoverUtil'
import opacity from '../../components/opacity/opacity-index'
export default {
  components: { pintuUploader, materialDialog, colorInput, opacity },
  props: {
    value: Object,
    tplData: Object
  },
  data () {
    return {
      bgVal: 0,
      pintuList: [],
      dialogVisible: false
    }
  },
  watch: {
    value: {
      handler (v) {
        if (v.type === 'img' && v !== this.oldValue) {
          this.oldValue = v
          this.init()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    isSingleTemplate () {
      return this.tplData.type === template_type_single
    },
    cutImgVisible () {
      if (this.value.type !== 'img') {
        return false
      }
      let { width, height, left, top, right, bottom } = this.value
      let tw = this.tplData.json.width,
        th = this.tplData.json.height
      let overTemplate =
        width > tw ||
        width > th ||
        left < 0 ||
        top < 0 ||
        right > tw ||
        bottom > th
      return overTemplate
    },
    isTemplateBg () {
      let { isBgImg, isPageBgImg } = this.value
      return this.isSingleTemplate ? isBgImg : isPageBgImg
    }
  },
  methods: {
    init () {
      let tplId = this.tplData.id
      if (!tplId) {
        return
      }
      if (this.isSingleTemplate) {
        this.initSingleBgVal()
      } else {
        this.initMultiBgVal()
      }
      this.getData()
    },
    getData () {
      this.getPTGroupData()
    },
    initMultiBgVal () {
      let value = this.value
      if (value.isPageBgImg) {
        // 模板背景优先判断
        this.bgVal = '3'
      } else if (value.isBgImg) {
        this.bgVal = '1'
      } else if (value.isBgMaterialImg) {
        this.bgVal = '2'
      }
    },
    initSingleBgVal () {
      let value = this.value
      if (value.isBgImg || value.isPageBgImg) {
        this.bgVal = '3'
      } else if (value.isActionBg) {
        this.bgVal = '4'
      }
    },
    onMultiBgValChange (v) {
      this.value.isBgImg = v === '1' ? true : false
      this.value.isBgMaterialImg = v === '2' ? true : false
      this.value.isPageBgImg = v === '3' ? true : false // 图文模板背景字段是isPageBgImg
    },
    onSingleBgValChange (v) {
      // banner模板 模板背景字段是isBgImg
      this.value.isBgImg = v === '3' ? true : false
      this.value.isPageBgImg = v === '3' ? true : false
      this.value.isActionBg = v === '4' ? true : false
    },
    getParentByChildren (parent, childItem) {
      parent.children.forEach(item => {
        if (item === childItem) {
          this.pData = parent
          return
        }
        if (item.children) {
          return this.getParentByChildren(item, childItem)
        }
      })
      return this.pData
    },
    /**
     * 双向扩展：文本和图片不能有父目录, 父目录影响元素宽度，导致文本自动换行
     * 垂直扩展：文本和图片需要在同一个目录下
     * 水平扩展：文本和图片无目录限制
     */
    onDirectionChange (value) {
      // if (this.tplData.type === template_type_single) {
      //     this.extendBySingleTemplate(dirValue)
      // } else {
      //     this.extendByMultiTemplate(dirValue)
      // }
      let item = this.$store.state.templateGroup.selectedItem
      let name = value ? `${value}_${new Date().getTime()}` : ''
      item.tagName = name
      let extendText = this.getExtendText(item)
      if (extendText) {
        extendText.direction = value
        extendText.tagName = name
      }
      let parent = this.getParentByChildren(this.tplData.json, this.value)
      parent.direction = value // 通过此属性设置父元素的css
    },
    extendBySingleTemplate (value) {
      let item = this.$store.state.templateGroup.selectedItem
      let name = value ? `${value}_${new Date().getTime()}` : ''
      item.tagName = name
      let extendText = this.getExtendText(item)
      if (extendText) {
        extendText.direction = value
        extendText.tagName = name
      }
    },
    deepChildren (children, dataList) {
      children.forEach(item => {
        if (item.children) {
          this.deepChildren(item.children, dataList)
        } else if (item.type === 'text') {
          dataList.push(item)
        }
      })
    },
    getExtendText (imgItem) {
      let dataList = [],
        overlap,
        item,
        textItem
      this.deepChildren(this.tplData.json.children, dataList)
      for (let i = 0; i < dataList.length; i++) {
        item = dataList[i]
        if (item.type === 'text') {
          overlap = item.right > imgItem.left && imgItem.right > item.left
          overlap =
            overlap && item.bottom > imgItem.top && imgItem.bottom > item.top
          if (overlap) {
            textItem = item
            break
          }
        }
      }
      return textItem
    },
    extendByMultiTemplate (dirValue) {
      let parent = this.getParentByChildren(this.tplData.json, this.value)
      parent.direction = dirValue // 通过此属性设置父元素的css
      if (this.value) {
        this.value.isBgImg = false
      }
    },
    getPTGroupData () {
      let paramsPT = {
        projectId: this.tplData.projectId,
        templateIds: [this.tplData.id],
        type: group_type_pt
      }
      groupService.getGroupList(paramsPT).then(({ list }) => {
        this.pintuList = list
      })
    },
    onUploadCompleted (dataList) {
      let cloneData = JSON.parse(JSON.stringify(dataList)).concat(
        this.pintuList
      )
      this.saveGroup(cloneData).then(() => {
        let { projectId, id } = this.tplData
        this.getPTGroupData(projectId, id)
      })
    },
    saveGroup (groupList) {
      let { id, projectId } = this.tplData
      let cloneData = JSON.parse(JSON.stringify(groupList))
      return groupService.addGroup(cloneData, projectId, id)
    },
    onDelGroupItem (item, index) {
      let { projectId } = this.tplData
      groupService.deleteGroups([item.id], projectId).then(() => {
        this.pintuList.splice(index, 1)
        this.$message.success('删除成功')
      })
    },
    formatterOpacityTip (val) {
      return `${val}%`
    },
    onBorderRadiusChange () {
      this.value.key = util.getUUID()
    },
    onOpenMaterialDialog () {
      this.dialogVisible = true
    },
    onConfirm (url, width, height) {
      this.value.url = url
      this.value.width = width
      this.value.height = height
      this.dialogVisible = false
    },
    onUploadBg () {
      this.eventBus.$emit('onReplaceBg')
    },
    onCoverBgChange (color) {
      ImgCoverUtil.setImgCover(color, this.value)
    }
  }
}
</script>
